import { render, staticRenderFns } from "./input-recipients-databases.vue?vue&type=template&id=75d2a97c&scoped=true&"
import script from "./input-recipients-databases.vue?vue&type=script&lang=js&"
export * from "./input-recipients-databases.vue?vue&type=script&lang=js&"
import style0 from "./input-recipients-databases.vue?vue&type=style&index=0&id=75d2a97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2a97c",
  null
  
)

export default component.exports